export default __webpack_public_path__ + "static/media/read-thumbnail.5ecf4d2b.png";